<!--    CONTENIDO     -->
<div class="outer-wrapper" igxLayout>
  <router-outlet></router-outlet>
</div>
<app-dinamico-host />
